import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root',
})
export class CedricApiService extends ApiService {
  public override api_url: string = this.environment.cedric_api_url;
}
